import { ColumnDefResolved } from "@tanstack/react-table"
import { Command } from "cmdk"

import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"
import generateRandomKey from "@utils/generateRandomKey"

import PopoverHeader from "@molecules/Popover/PopoverHeader/PopoverHeader"
import { Popover } from "@molecules/index"

import ComponentNavigation from "@organisms/ComponentNavigation/ComponentNavigation"
import { useComponentNavigation } from "@organisms/ComponentNavigation/ComponentNavigation.context"
import useTable from "@organisms/Table/Table.context"

import styles from "./PopoverAddColumns.module.scss"
import { PopoverAddColumnsProps } from "./PopoverAddColumns.types"

export default function PopoverAddColumns(props: PopoverAddColumnsProps) {
    const { isVisible } = props

    const { invisibleColumns, updateColumnVisibility } = useTable()
    const { isComponentTransitioning } = useComponentNavigation()
    const isDesktop = useIsDesktop()

    const handleColumnVisibilityChange = (column: ColumnDefResolved<unknown>) => {
        updateColumnVisibility(column.accessorKey as string, true)
    }

    const noColumns = invisibleColumns.length === 0

    return (
        <Command>
            <ComponentNavigation.Content animationType="fade">
                <PopoverHeader.Root>
                    <PopoverHeader.BackButton backDestination={isDesktop ? "main" : "columns"} aria-label="Back" />
                    <PopoverHeader.Title title="Add Columns" />
                </PopoverHeader.Root>
            </ComponentNavigation.Content>
            <ComponentNavigation.Content animationType="slide">
                <Command.List>
                    <Command.Empty>
                        <div className={styles.noColumns}>
                            <div className={styles.noColumnsText}>No columns {noColumns ? "to add" : "found"}</div>
                        </div>
                    </Command.Empty>
                    <Command.Group className={styles.items}>
                        {invisibleColumns.map((column) => (
                            <Command.Item
                                key={generateRandomKey()}
                                value={column.header as string}
                                disabled={isComponentTransitioning}
                            >
                                <Popover.Button
                                    icon={faIcon({ name: "plus", style: "regular" })}
                                    isTabbable={isVisible}
                                    onClick={() => handleColumnVisibilityChange(column)}
                                >
                                    {column.header as string}
                                </Popover.Button>
                            </Command.Item>
                        ))}
                    </Command.Group>
                </Command.List>
            </ComponentNavigation.Content>
        </Command>
    )
}
